import createTypes from 'redux-create-action-types';

export default createTypes(
  'GET_DESKTOP_REVIEW_DETAIL',
  'GET_DESKTOP_REVIEW_REPORTS',
  'GET_DESKTOP_REVIEW_REPORTS_DETAIL',
  'GET_DESKTOP_REVIEW_MESSAGE',
  'GET_DESKTOP_REVIEW_QUOTATIONS',
  'GET_DESKTOP_REVIEW_QUOTE_DETAIL',
  'EXPORT_DESKTOP_REVIEW'
);
